export const LIVE_CASINO_LOBBY_ID = 198;

const NON_SLOT_LOBBY_IDS = new Set([
  LIVE_CASINO_LOBBY_ID,
  312,
  48,
  284,
  293,
]);

/** Pages/lobbies where bonus balance is shown/spent (slots only). */
export function isBonusEligiblePage(page, route = {}) {
  if (page === 'sport') return false;
  if (page === 'casino') {
    if (route?.lobbyKey && route.lobbyKey !== 'slots') return false;
    const lobbyId = route?.casinoLobbyId;
    if (lobbyId != null && lobbyId !== '' && NON_SLOT_LOBBY_IDS.has(Number(lobbyId))) {
      return false;
    }
    return true;
  }
  return true;
}

export function isBonusIneligibleNavigation(nextPage, opts = {}) {
  if (nextPage === 'sport') return true;
  if (nextPage !== 'casino') return false;
  if (opts.lobbyKey && opts.lobbyKey !== 'slots') return true;
  const lobbyId = opts.casinoLobbyId;
  if (lobbyId != null && lobbyId !== '' && NON_SLOT_LOBBY_IDS.has(Number(lobbyId))) {
    return true;
  }
  return false;
}

export function userWalletMode(user) {
  return String(user?.wallet_mode || user?.walletMode || 'cash').toLowerCase() === 'bonus'
    ? 'bonus'
    : 'cash';
}

export function headerDisplayBalance(user, { page, route } = {}) {
  const mode = userWalletMode(user);
  const cash = Number(user?.balance || 0);
  const bonus = Number(user?.bonus_balance ?? user?.bonusBalance ?? 0);
  const hasBonusBalance = Number.isFinite(bonus) && bonus > 0.009;
  const sportUsesBonus = page === 'sport' && hasBonusBalance && (mode === 'bonus' || !(cash >= 1));
  const showBonus = sportUsesBonus || (mode === 'bonus' && isBonusEligiblePage(page, route));
  if (showBonus) {
    return {
      amount: bonus,
      cashAmount: cash,
      bonusAmount: bonus,
      mode: 'bonus',
      showBadge: true,
      showDual: hasBonusBalance,
    };
  }
  return {
    amount: cash,
    cashAmount: cash,
    bonusAmount: bonus,
    mode: 'cash',
    showBadge: false,
    showDual: hasBonusBalance,
  };
}
